"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("./button.style"));

var _navbar = _interopRequireDefault(require("./navbar.style"));

var _icon = _interopRequireDefault(require("../../icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Navbar = ({
  onPreviousClick,
  onNextClick,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_navbar.default, props, /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: () => onPreviousClick()
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "chevron_left"
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: () => onNextClick()
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "chevron_right"
  })));
};

Navbar.propTypes = {
  onPreviousClick: _propTypes.default.func,
  onNextClick: _propTypes.default.func
};
var _default = Navbar;
exports.default = _default;